import {
  failureAction, successAction, startAction,
} from '../../common'
import { GET_ISSUES_IN_PROGRESS } from '../types'

export const initialState = {
  loading: false,
  loaded: false,
  error: {},
  data: {
    numResults: 0,
    docs: [],
  },
}

const reducer = ({ inProgress: state }, action) => {
  switch (action.type) {
    case startAction(GET_ISSUES_IN_PROGRESS):
      return {
        ...initialState,
        loading: true,
        loaded: false,
      }
    case successAction(GET_ISSUES_IN_PROGRESS):
      return {
        ...state,
        loading: false,
        loaded: true,
        error: {},
        data: action.payload,
      }
    case failureAction(GET_ISSUES_IN_PROGRESS):
      return {
        ...initialState,
        error: action.payload,
      }

    default:
      return state
  }
}

export default reducer
